import { initialState } from '../../store/initialState';
import uiReducer from './uiReducer';

export default (state = initialState.ui, action) => {
	const ui = uiReducer(state, action);
	return ui;
};
